import LocalizedStrings from "react-localization"

import en from "./en"

const strings = new LocalizedStrings({
  en,
})

// FIX 2026-07-04 (toast repair): several call sites (ported from mobile, where i18n-js
// provides I18n.t) call I18n.t("key") -- react-localization has no .t(), so those calls
// threw "I18n.t is not a function" and e.g. the canonical terminal-stage rejection toast
// never rendered. Provide a .t shim over getString (supports dotted paths like
// "teeup.toastMsg.forbiddenDecideGP"); falls back to the key so a missing string never throws.
strings.t = function (key) {
  try {
    const value = this.getString(key)
    if (value !== null && value !== undefined) return value
  } catch (error) {
    /* fall through to key */
  }
  return key
}

export default strings
